import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

interface DeleteDialogProps {
  recipeName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteDialog({ recipeName, onConfirm, onCancel }: DeleteDialogProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in"
      onClick={onCancel}
    >
      <div className="absolute inset-0 bg-foreground/20 backdrop-blur-sm" />
      <Card
        className="relative w-full max-w-sm p-6 animate-scale-in bg-card border-border/60"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-destructive/10 mb-4 mx-auto">
          <svg
            className="w-6 h-6 text-destructive"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M3 6h18" />
            <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
            <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
          </svg>
        </div>
        <h3
          className="text-lg font-semibold text-center mb-2"
          style={{ fontFamily: "var(--font-display)", fontWeight: 600 }}
        >
          Удалить рецепт?
        </h3>
        <p
          className="text-sm text-center text-muted-foreground mb-6"
          style={{ fontFamily: "var(--font-body)" }}
        >
          Рецепт «{recipeName}» будет удалён без возможности восстановления.
        </p>
        <div className="flex gap-3 justify-center">
          <Button
            variant="outline"
            size="sm"
            onClick={onCancel}
            className="border-border/60 min-w-[90px]"
          >
            Отмена
          </Button>
          <Button
            variant="destructive"
            size="sm"
            onClick={onConfirm}
            className="min-w-[90px]"
          >
            Удалить
          </Button>
        </div>
      </Card>
    </div>
  );
}
